import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { Environment } from "./config"
import { Config } from "./config"
import { Color } from "../constants"
import { AuthAccount2 } from "../graphql/types"

export const getMainColor = (env: Environment): string => {
    switch (env) {
        case Environment.Production:
            return Color.PrimaryColor
        default:
            return Color.Purple
    }
}

export const getMibUrlAddress = (val: Maybe<string>, account: Maybe<AuthAccount2>) => {
    if (!val) {
        return null
    }

    if (val.includes("http")) {
        return val
    }

    if (!account || !account.domainName) {
        return `${Config.mibBaseUrl}${val}`
    }

    return `https://${account.domainName}${val}`
}

export const appendAssetsHostnameToUrl = (val: Maybe<string>) => {
    if (!val) {
        return null
    }

    if (val.startsWith("http") || val.startsWith("data:")) {
        return val
    }

    return `${Config.mibBaseUrl}${val}`
}

export const stripHostnameFromAssetsUrl = (url: Maybe<string>): Maybe<string> => {
    if (url?.startsWith(Config.mibBaseUrl)) {
        return url.replace(Config.mibBaseUrl, "")
    }

    return url
}

export const isLocalhost = () => Config.appUrl.includes("localhost")
